import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import RupeeTextField from '../common/RupeeTextfield';
import styles from './WithdrawFunds.module.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import RecentWithdrawalsListController from './RecentWithdrawalsListController';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import {
  Typography,
  Container,
  List,
  ListItem,
  ListItemText,
  TextField,
  Stack,
  useMediaQuery,
  Button,
  Autocomplete,
  FormControl,
  FormHelperText,
  Toolbar
} from '@mui/material';
import { Box } from '@mui/system';
import { useAppData } from '../../redux/appDataProvider';
import AppConfig from '../../AppConfig';
import ApiClient from '../../utilities/apiClient';
import { useSelector } from 'react-redux';

const WithdrawFunds = ({ data }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const screenSize = useMediaQuery('(max-width : 500px)')
  const screen1000px = useMediaQuery('(max-width : 1000px)')
  const navigate = useNavigate()
  const apiToken = useSelector(state => state.auth.apiToken);
  const { userBanks, setuserBanks } = useAppData();
  const [selectedBank, setBank] = useState('');
  const [submitdata, setSubmtData] = useState('');
  const [errtype, setErrorType] = useState(0);
  const [errmsg, setErrMag] = useState('');
  // Changed to null to string - 23-07-24 - Dev Srini
  const [amount, setAmount] = useState("");
  const { withdrawinfo, setWithdrawinfo } = useAppData();
  const { userInfo, setUserInfo } = useAppData();
  const { selectedYear, setSelectedYear } = useAppData();

  useEffect(() => {
    if (userBanks?.length == 1) {
      setBank(userBanks[0])
    } else {
      const defaultBank = userBanks?.length > 0 && userBanks.find(ele => ele.Default_Ac == "Yes")
      setBank(defaultBank)
    }

  }, [userBanks])

  const handleBankChange = (event, newValue) => {
    setErrorType(0)
    setBank(newValue);
  };
  const handleAmountValueChange = (values) => {
    // update value - 23-07-24 - Dev Srini
    setAmount(values.slice(1));
    setErrorType(0)
  };
  const handleSubmit = () => {
    if (!selectedBank) {
      setErrMag("Please select a bank!");
      setErrorType(1)

      return;
    }
    if (!amount) {
      setErrMag("Enter the Amount to Withdraw");
      setErrorType(2)

      return;
    }

    if (parseFloat(amount.replaceAll(",","")) > parseFloat(withdrawinfo.Release.replaceAll(",",""))) {

      setErrMag("Amount is greater than Withdrawal Balance");
      setErrorType(2)

      return;
    }
    // reset amount value 18-07-24 Dev Srini
    setAmount('')

    let tdate = dayjs(new Date()).format('DD/MM/YYYY')
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Withdraw.submit,
        "POST",
        {

          "client_id": userInfo.CLIENT_ID,
          "company_code": "GRP1",
          "VOUCHERDATE": tdate,
          "Amount": amount.replaceAll(",",''),
          "BankAccountNumber": selectedBank.Bank_AcNo,
          "MicrNo": selectedBank.Bank_AcNo.Micr_Code,
          "IFSC_code": selectedBank.IFSC_Code,


        })
        .then((response) => {
          console.info(response);

          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];
            console.info(`data ${responseData}`);
            setSubmtData(responseData)
            fetchBalance()
            
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }
  useEffect(() => {
    // Simulate fetching data from an API or some other source
    fetchBalance();
    //fetchTxList();
  }, [selectedYear.Database_Year]); // dependancy, srini - 30-01-25
 
  const fetchBalance = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      let tdate = dayjs(new Date()).format('DD/MM/YYYY')
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Withdraw.balance,
        "POST",
        {
          "Client_ID": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
          "Company_Code": "GRP1",
          "Datayear": selectedYear.Database_Year === '2023' ? '2024' : (selectedYear.Database_Year || (localStorage.getItem("year") === '2023' ? '2024' : localStorage.getItem("year"))) // omitting 2023, srini - 30-01-25
        })
        .then((response) => {
          console.info(response);
          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];

            if (Array.isArray(responseData) && responseData.length > 0) {
              console.info('withdraw info ', responseData[0].Release);


              setWithdrawinfo(responseData[0]);


            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };

  return (
    <Container component="main" className={styles.withdrawfunds} maxWidth="lg" sx={{ background: isSmallScreen && "#1B2636", padding: "0px 0px !important", minHeight: "100vh" }}>
      {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
      {isSmallScreen &&
        <Button onTouchStart={() => navigate("/dashboard")} sx={{ color: "#F3D45E", backgroundColor: "transparent", marginLeft: "10px", fontSize: "20px" }} ><ArrowBackIosIcon fontSize='10px' />Back</Button>
      }
      <Toolbar className={styles.toolbar} sx={{ paddingLeft: '16px' }}>
        {/* Font size changed to 20px - 29-07-24 - Dev Srini */}
        <Typography variant="h6" component="div" sx={{ marginLeft: isSmallScreen ? "0px" : "-25px", display: 'flex', alignItems: 'center', flexGrow: 1, textAlign: 'left' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px' }}>
            <path d="M16 12H18V16H16V12Z" fill="white" />
            <path d="M20 7V5C20 3.897 19.103 3 18 3H5C3.346 3 2 4.346 2 6V18C2 20.201 3.794 21 5 21H20C21.103 21 22 20.103 22 19V9C22 7.897 21.103 7 20 7ZM5 5H18V7H5C4.74252 6.98848 4.49941 6.87809 4.32128 6.69182C4.14315 6.50554 4.04373 6.25774 4.04373 6C4.04373 5.74226 4.14315 5.49446 4.32128 5.30818C4.49941 5.12191 4.74252 5.01152 5 5ZM20 19H5.012C4.55 18.988 4 18.805 4 18V8.815C4.314 8.928 4.647 9 5 9H20V19Z" fill="white" />
          </svg>
          Withdraw Funds
        </Typography>
        {!isSmallScreen &&
          <Button onClick={() => navigate("/dashboard")} variant='text' sx={{
            color: "#F3D45E", backgroundColor: "transparent", marginRight: "-10px", '&:hover': {
              backgroundColor: 'transparent',
            }
          }}  ><ArrowBackIosIcon fontSize='10px' />Back</Button>}
      </Toolbar>
      {/* start, text added - srini - 30-01-25 */}
      <Box >
        <Typography sx={{ fontSize: isSmallScreen ?  '10px' : '12px', marginLeft: isSmallScreen ? '20px' : '32px', letterSpacing: '0.2px', color:'#F3D45E' }}>*The balance displayed corresponds to the current financial year.</Typography>
      </Box>
      {/* end - srini - 30-01-25 */}
      {isSmallScreen ?
        <Grid container spacing={3} marginBottom={2}>
          <Grid xs={12} justifyContent="left" alignItems="left">
            <List sx={{ marginLeft: "20px" }} className={styles.list}>
              <ListItem disablePadding>
                <ListItemText
                  primary={`Closing Balance: ₹${withdrawinfo.Closing}`}
                  sx={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '400'
                  }} />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText
                  primary={`Net Without Margin: : ₹ ${withdrawinfo.NetWMrg}`}
                  sx={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '400'
                  }} />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText
                  primary={`Releasable Balance : ₹ ${withdrawinfo.ToBeRelease}`}
                  sx={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '400'
                  }} />
              </ListItem>
              {/*data.accountDetails.map((item, index) => (
                  <ListItem  key={index} disablePadding>
                    <ListItemText 
                      primary={`${item.text} : ₹ ${item.value}`} 
                      sx={{ 
                        textAlign: 'left',
                        color: '#FFFFFF',
                        fontSize: '14px',
                        fontWeight: '400'  
                      }}/> 
                  </ListItem>
                    ))*/}
            </List>
            <Grid xs={12} sx={{ margin: "15px 0px 0px 25px" }}>
              <Typography
                sx={{
                  color: "#7DAB1C",
                  fontSize: '25px',
                  fontWeight: 400
                }}>
                ₹ {withdrawinfo.Release}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#999999",
                  fontSize: '14px',
                  fontWeight: 400
                }}>
                Withdrawable Balance
              </Typography>
            </Grid>
          </Grid>
          <Grid xs={12} md={12} sx={{ margin: "-5px 15px 0px 15px" }}>
            <FormControl style={{ width: '100%' }} variant="standard">
              <Autocomplete
                disablePortal
                size='small'
                // id="combo-box-demo"
                options={userBanks}
                value={selectedBank}
                autoSelect={true}
                onChange={handleBankChange}
                getOptionLabel={(option) => `${option.Bank_Name} - ${option.Bank_AcNo}`}
                sx={{
                  width: "100%",
                  height: "40px",
                  borderRadius: "5px",
                  backgroundColor: "#0B1420",
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" }
                }}
                renderInput={(params) => <TextField {...params} label="Select Bank Account" />}
              />
              {errtype === 1 &&
                <FormHelperText className={styles.errtxt} id="component-error-text">{errmsg}</FormHelperText>
              }
            </FormControl>
          </Grid>
          <Grid xs={6} md={5} sx={{ marginTop: "-25px" }}>
            {/* amount state value passing - 23-07-24 - Dev Srini */}
            <RupeeTextField amount={amount} handleAmountValueChange={handleAmountValueChange} />

            {errtype === 2 &&
              <FormHelperText className={styles.errtxt} id="component-error-text">
                <span style={{ marginLeft: "25px", whiteSpace: "nowrap" }}>{errmsg}</span>
              </FormHelperText>}
          </Grid>
          <Grid xs={6} md={5} sx={{ marginTop: "-15px", display: 'flex', alignItems: 'start', justifyContent: 'end' }}>
            <Button
              variant="contained"
              size="medium"
              sx={{
                width: "100%",
                height: "40px",
                marginRight: "15px"
              }}
              // Changed to onTouch event - 23-07-24 - Dev Srini
              onTouchStart={() => handleSubmit()}
            >Submit</Button>
          </Grid>
        </Grid>
        :
        <Grid xs={12} container spacing={2} minHeight={160}>
          <Grid xs={screen1000px ? 7.5 : 4.6} display="flex" justifyContent="left" alignItems="center">
            <List className={styles.list}>
              <ListItem disablePadding>
                <ListItemText
                  primary={`Closing Balance: ₹${withdrawinfo.Closing}`}
                  sx={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '400'
                  }} />

              </ListItem>
              <ListItem disablePadding>
                <ListItemText
                  primary={`Net Without Margin: : ₹ ${withdrawinfo.NetWMrg}`}
                  sx={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '400'
                  }} />

              </ListItem>
              <ListItem disablePadding>
                <ListItemText
                  primary={`Releasable Balance: ₹ ${withdrawinfo.ToBeRelease}`}
                  sx={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '400'
                  }} />

              </ListItem>
              {/* <ListItem   disablePadding>
                    <ListItemText 
                      primary={`Collateral Utilised: ₹ 1000000000.00`} 
                      sx={{ 
                        textAlign: 'left',
                        color: '#FFFFFF',
                        fontSize: '14px',
                        fontWeight: '400'  
                      }}/>
                    
                  </ListItem> */}
            </List>
          </Grid>
          <Grid xs={screen1000px ? 4.5 : 3.5} display="flex" justifyContent="center" alignItems="end">
            <Box sx={{ width: '100%', marginBottom: "14px", marginLeft: "10px" }}>
              <Typography
                variant="h4"
                sx={{
                  color: "#03E743",
                  fontSize: '25px',
                  fontWeight: 400,
                  marginBottom: "20px",
                  textWrap: "nowrap"
                }}
                component="h4">
                ₹ {withdrawinfo.Release}
                {/* ₹ 1000000000.00 */}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#FFFFFF",
                  fontSize: '14px',
                  fontWeight: 400,
                  textWrap: "nowrap"
                }}>
                Withdrawable Balance
              </Typography>
            </Box>
          </Grid>
          <Grid xs={screen1000px ? 7 : 3.9} border="0px solid white" container alignItems="center">
            <Grid xs={12}>
              <FormControl style={{ width: '100%' }} variant="standard">
                <Autocomplete
                  disablePortal
                  size='small'
                  // id="combo-box-demo"
                  options={userBanks}
                  value={selectedBank}
                  autoSelect={true}
                  onChange={handleBankChange}
                  getOptionLabel={(option) => `${option.Bank_Name} - ${option.Bank_AcNo}`}
                  sx={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#131E2E",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Bank Account" />}
                />
                {errtype === 1 &&
                  <FormHelperText className={styles.errtxt} id="component-error-text">{errmsg}</FormHelperText>
                }
              </FormControl>

            </Grid>

            <Grid xs={8} sx={{ marginTop: screen1000px ? "-10px" : "-30px" }}>
              <FormControl style={{ width: '100%' }} variant="standard">
                {/* state value passing - 23-07-24 - Dev Srini */}
                <RupeeTextField amount={amount} handleAmountValueChange={handleAmountValueChange} />
                {errtype === 2 &&
                  <FormHelperText className={styles.errtxt} id="component-error-text">{errmsg}</FormHelperText>
                }
              </FormControl>

            </Grid>
            <Grid xs={4} sx={{ marginTop: "5px" }}>
              <Button fullWidth sx={{ marginTop: screen1000px ? "-5px" : "-30px", height: "40px", fontWeight: "bold" }} variant="contained"
                onClick={() => handleSubmit()}
              >Submit</Button>
            </Grid>
          </Grid>
        </Grid>
      }
      <Grid container zeroMinWidth={true} spacing={0} alignItems="center" sx={{ marginTop: !isSmallScreen && "40px" }} >

        <RecentWithdrawalsListController
          submitdata={submitdata}
          fetchBalance={fetchBalance}
        />

      </Grid>
    </Container>
  );
};
export default WithdrawFunds;
